'use client';

import { FooterLinkTab } from '@/constants';
import { getHousingFooterTabs } from '@/features/pages/housing-detail/api/getCachedHousingDetail';
import { createContext, useContext, useEffect, useMemo, useState } from 'react';

type FooterTabsContextValue = {
  detailTabs: FooterLinkTab[] | null;
  setDetailTabs: (tabs: FooterLinkTab[] | null) => void;
};

const FooterTabsContext = createContext<FooterTabsContextValue | null>(null);

export const FooterTabsProvider = ({ children }: { children: React.ReactNode }) => {
  const [detailTabs, setDetailTabs] = useState<FooterLinkTab[] | null>(null);
  const value = useMemo(() => ({ detailTabs, setDetailTabs }), [detailTabs]);

  return <FooterTabsContext.Provider value={value}>{children}</FooterTabsContext.Provider>;
};

export const useFooterTabs = (): FooterTabsContextValue => {
  const context = useContext(FooterTabsContext);
  if (!context) {
    throw new Error('useFooterTabs must be used within FooterTabsProvider');
  }
  return context;
};

export const HousingDetailFooterTabsSetter = ({ housingId }: { housingId: string }) => {
  const { setDetailTabs } = useFooterTabs();

  useEffect(() => {
    void getHousingFooterTabs(housingId).then(setDetailTabs);
    return () => setDetailTabs(null);
  }, [housingId, setDetailTabs]);

  return null;
};
